/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error",
  { "props": true, "ignorePropertyModificationsFor": ["state"] }] */

import Vue from 'vue';
import Vuex from 'vuex';
import state from '../../config/monm-law/state';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  mutations: {
    UPDATE_VOTE_COUNT(state, voteCount) {
      state.vote_count = voteCount;
    },
    CHANGE_EXPIRATION_DATE(state, newDate) {
      state.expiration_date = newDate;
    },
    REMOVE_LOGO(state) {
      state.publication_logo = null;
    },
    CHANGE_LOGO(state, uri) {
      state.publication_logo = uri;
    },
    REMOVE_WELCOME_TEXT(state) {
      state.welcome = null;
    },
    REMOVE_HEADER_TEXT(state) {
      state.survey_title = null;
    },
    REMOVE_SUBHEADER_TEXT(state) {
      state.survey_subtitle = null;
    },
    UPDATE_UUID(state, uuid) {
      state.uuid = uuid;
    },
  },
  actions: {
    updateVoteCount({ commit }) {
      let voteCount = 0;
      [...document.querySelectorAll('.vote-field')].forEach((input) => {
        if (input.value !== '') {
          voteCount += 1;
        }
      });
      commit('UPDATE_VOTE_COUNT', voteCount);
    },
    resetVoteCount({ commit }) {
      commit('UPDATE_VOTE_COUNT', 0);
    },
    changeExpirationDate({ commit }, newDate) {
      commit('CHANGE_EXPIRATION_DATE', newDate);
    },
    changeLogo({ commit }, uri) {
      if (uri === null) {
        commit('REMOVE_LOGO');
      } else {
        commit('CHANGE_LOGO', uri);
      }
    },
    createUuid({ commit }) {
      /* https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript */
      const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
      if (isIE11) {
        const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ msCrypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)); /* eslint-disable-line */
        commit('UPDATE_UUID', uuid);
      } else {
        const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)); /* eslint-disable-line */
        commit('UPDATE_UUID', uuid);
      }
    },
  },
  getters: {
    fields: (state) => {
      const orderedFields = {};
      Object.keys(state.fields).sort().forEach((key) => {
        orderedFields[key] = state.fields[key];
      });
      return orderedFields;
    },
    title: state => state.survey_title,
  },
});
